'use client'

import { Instance } from '@nutrient-sdk/viewer'
import { createContext, useContext, useState, ReactNode } from 'react'

type PdfInstanceContextType = {
  pspdfkitInstance: Instance | null
  setPspdfkitInstance: (instance: Instance | null) => void
}

const PdfInstanceContext = createContext<PdfInstanceContextType | undefined>(
  undefined
)

export function PdfInstanceProvider({ children }: { children: ReactNode }) {
  const [pspdfkitInstance, setPspdfkitInstance] = useState<Instance | null>(
    null
  )

  return (
    <PdfInstanceContext.Provider
      value={{ pspdfkitInstance, setPspdfkitInstance }}
    >
      {children}
    </PdfInstanceContext.Provider>
  )
}

export function usePdfInstance() {
  const context = useContext(PdfInstanceContext)
  if (context === undefined) {
    throw new Error('usePdfInstance must be used within a PdfInstanceProvider')
  }
  return context
}
